import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// 各个国家的key
const localeKeys = [
  'en', 'zh-CN', 'ko', 'jp',
  'vi', 'hi', 'th', 'ru'  // 新增语言键
];

const messages = {};
for (const key of localeKeys) {
  try {
    const langObj = require(`./locales/${key}`).default;
    messages[key] = { ...langObj };
  } catch (error) {
    console.warn(`语言包 ${key} 加载失败:`, error);
  }
}

export default new VueI18n({
  locale: localStorage.getItem('change-language') || 'zh-CN', // 默认改为韩语
  messages,
  silentTranslationWarn: true // 忽略翻译警告
});